import { heroFeature, heroStack } from "@/mocks/headlines";

function CatPill({ cat }: { cat: string }) {
  const tone =
    cat === "实锤讨论"
      ? "bg-primary-100 text-primary-800"
      : cat === "时间线"
      ? "bg-accent-100 text-accent-900"
      : cat === "后续进展"
      ? "bg-secondary-200 text-secondary-900"
      : "bg-secondary-100 text-secondary-900";
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${tone}`}>
      {cat}
    </span>
  );
}

export default function Hero() {
  return (
    <section id="focus" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-6 md:px-6 md:py-8">
      {/* 栏目标题 */}
      <div className="mb-5 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 bg-primary-500" />
          <h2 className="font-heading text-xl font-bold md:text-2xl">今日焦点 · 多卡直给</h2>
        </div>
        <p className="text-xs text-foreground-500 md:text-sm">封面驱动排版，重点事件一眼抓取，深度入口已按时间线对齐</p>
      </div>

      <div className="grid gap-5 lg:grid-cols-3">
        {/* 主卡 */}
        <a
          href="#review"
          className="group relative overflow-hidden bg-foreground-950 lg:col-span-2 lg:row-span-2"
        >
          <div className="relative h-56 overflow-hidden sm:h-72 md:h-80 lg:h-full lg:min-h-[520px]">
            <img
              src={heroFeature.cover}
              alt={heroFeature.title}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/35 to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
                {heroFeature.kicker}
              </span>
              <span className="rounded-md bg-accent-500/90 px-2 py-0.5 text-xs font-semibold text-background-50">
                <i className="ri-flashlight-fill mr-1" />
                {heroFeature.hot}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
              {heroFeature.title}
            </h3>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100/90 sm:block">
              {heroFeature.summary}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-200">
              <span className="flex items-center gap-1">
                <i className="ri-vidicon-line" /> {heroFeature.source}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line" /> {heroFeature.readTime}
              </span>
              <span className="ml-auto inline-flex items-center gap-1 font-semibold text-accent-300">
                进入完整复盘 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </div>
        </a>

        {/* 侧列小卡 */}
        {heroStack.map((it) => (
          <a
            key={it.id}
            href="#discussion"
            className="group flex gap-3 border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-background-300"
          >
            <div className="h-20 w-24 shrink-0 overflow-hidden sm:h-24 sm:w-32">
              <img
                src={it.cover}
                alt={it.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <div className="flex min-w-0 flex-col justify-between py-0.5">
              <CatPill cat={it.cat} />
              <h4 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950">
                {it.title}
              </h4>
              <div className="flex items-center justify-between text-[11px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-600" /> {it.heat}
                </span>
                <span className="hidden rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900 sm:inline">
                  {it.tag}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}